import * as videosServices from './videosServices';

export { videosServices };
